module.exports = __webpack_public_path__ + "img/quickmenu_jp.381ff79.jpg";